"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SurveyResultsByTypeToJSON = exports.SurveyResultsByTypeFromJSONTyped = exports.SurveyResultsByTypeFromJSON = exports.instanceOfSurveyResultsByType = exports.SurveyResultsByTypeAnswerSelectionTypeEnum = void 0;
var runtime_1 = require("../runtime");
var SurveyAgeGroupStats_1 = require("./SurveyAgeGroupStats");
var SurveyAnswerStatistics_1 = require("./SurveyAnswerStatistics");
var SurveyFormatGroupStats_1 = require("./SurveyFormatGroupStats");
var SurveyFrequencyGroupStats_1 = require("./SurveyFrequencyGroupStats");
var SurveyGenderGroupStats_1 = require("./SurveyGenderGroupStats");
var SurveyGroupStats_1 = require("./SurveyGroupStats");
var SurveyQuestionType1_1 = require("./SurveyQuestionType1");
/**
 * @export
 */
exports.SurveyResultsByTypeAnswerSelectionTypeEnum = {
    Unset: 'UNSET',
    SingleSelect: 'SINGLE_SELECT',
    MultiSelect: 'MULTI_SELECT'
};
/**
 * Check if a given object implements the SurveyResultsByType interface.
 */
function instanceOfSurveyResultsByType(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfSurveyResultsByType = instanceOfSurveyResultsByType;
function SurveyResultsByTypeFromJSON(json) {
    return SurveyResultsByTypeFromJSONTyped(json, false);
}
exports.SurveyResultsByTypeFromJSON = SurveyResultsByTypeFromJSON;
function SurveyResultsByTypeFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'questionText': !(0, runtime_1.exists)(json, 'question_text') ? undefined : json['question_text'],
        'questionType': !(0, runtime_1.exists)(json, 'question_type') ? undefined : (0, SurveyQuestionType1_1.SurveyQuestionType1FromJSON)(json['question_type']),
        'answerSelectionType': !(0, runtime_1.exists)(json, 'answer_selection_type') ? undefined : json['answer_selection_type'],
        'answerStatistics': !(0, runtime_1.exists)(json, 'answer_statistics') ? undefined : (json['answer_statistics'].map(SurveyAnswerStatistics_1.SurveyAnswerStatisticsFromJSON)),
        'totalGroupStats': !(0, runtime_1.exists)(json, 'total_group_stats') ? undefined : (0, SurveyGroupStats_1.SurveyGroupStatsFromJSON)(json['total_group_stats']),
        'ageGroupStats': !(0, runtime_1.exists)(json, 'age_group_stats') ? undefined : (json['age_group_stats'].map(SurveyAgeGroupStats_1.SurveyAgeGroupStatsFromJSON)),
        'genderGroupStats': !(0, runtime_1.exists)(json, 'gender_group_stats') ? undefined : (json['gender_group_stats'].map(SurveyGenderGroupStats_1.SurveyGenderGroupStatsFromJSON)),
        'formatGroupStats': !(0, runtime_1.exists)(json, 'format_group_stats') ? undefined : (json['format_group_stats'].map(SurveyFormatGroupStats_1.SurveyFormatGroupStatsFromJSON)),
        'frequencyGroupStats': !(0, runtime_1.exists)(json, 'frequency_group_stats') ? undefined : (json['frequency_group_stats'].map(SurveyFrequencyGroupStats_1.SurveyFrequencyGroupStatsFromJSON)),
    };
}
exports.SurveyResultsByTypeFromJSONTyped = SurveyResultsByTypeFromJSONTyped;
function SurveyResultsByTypeToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'question_text': value.questionText,
        'question_type': (0, SurveyQuestionType1_1.SurveyQuestionType1ToJSON)(value.questionType),
        'answer_selection_type': value.answerSelectionType,
        'answer_statistics': value.answerStatistics === undefined ? undefined : (value.answerStatistics.map(SurveyAnswerStatistics_1.SurveyAnswerStatisticsToJSON)),
        'total_group_stats': (0, SurveyGroupStats_1.SurveyGroupStatsToJSON)(value.totalGroupStats),
        'age_group_stats': value.ageGroupStats === undefined ? undefined : (value.ageGroupStats.map(SurveyAgeGroupStats_1.SurveyAgeGroupStatsToJSON)),
        'gender_group_stats': value.genderGroupStats === undefined ? undefined : (value.genderGroupStats.map(SurveyGenderGroupStats_1.SurveyGenderGroupStatsToJSON)),
        'format_group_stats': value.formatGroupStats === undefined ? undefined : (value.formatGroupStats.map(SurveyFormatGroupStats_1.SurveyFormatGroupStatsToJSON)),
        'frequency_group_stats': value.frequencyGroupStats === undefined ? undefined : (value.frequencyGroupStats.map(SurveyFrequencyGroupStats_1.SurveyFrequencyGroupStatsToJSON)),
    };
}
exports.SurveyResultsByTypeToJSON = SurveyResultsByTypeToJSON;
